export default {
	1: 'Coś poszło nie tak, spróbuj ponownie',
	2: 'Serwer blokady w magazynie nie jest dostępny',

	1000: 'Wymagany adres e-mail',
	1001: 'Nieprawidłowy e-mail',
	1002: 'Nieprawidłowe hasło',
	1003: 'Pole jest wymagane',
	1004: 'Niedozwolona liczba symboli',

	1077: 'Nie znaleziono aktualnych faktur',

	5000: 'Użytkownik ma aktywne umowy. Proszę, sprawdź je',

	6001: 'Box jest już zarezerwowany',
	6002: 'Nieznany użytkownik',
	6003: 'Boksy lub magazyny muszą być dostarczone',
	6004: 'Nie znaleziono użytkownika',
	6005: 'Nie znaleziony boks',
	6006: 'Magazyn nie został znaleziony',
	6007: 'Ten boks jest umieszczony nie w tym magazynie',
	6008: 'Wymagany jest identyfikator klienta',
	6009: 'Aby otworzyć drzwi, musisz połączyć się z siecią Wi-Fi magazynu',
	6010: 'Przepraszamy, nie ma dostępnych boksów z podanymi parametrami',
	6011: 'Numer blokady jest już używany',
	6013: 'Zła konfiguracja identyfikatora blokady',

	7000: 'Brak płatności',
	7001: 'Twój profil nie jest zweryfikowany. Nie możesz wykonać tej akcji',
	7003: 'Data rozpoczęcia umowy jeszcze nie nadeszła',
	7005: 'Contract is not started',


	9000: 'Użytkownik z takim adresem e-mail już istnieje.',
	9001: 'Niepoprawne dane.',
	9003: 'Zaloguj się, proszę.',

	unrecognized: 'Coś poszło nie tak. Proszę spróbować ponownie później.',
	error: 'Błąd',
};
